<template>
  <b-modal
    id="configure-y-axis-modal"
    ref="modal"
    title="Configure Y Axis"
    @ok="updateYAxisConfiguration"
  >
    <div class="y-axis-configuration">
      <div>
        <span> Y Axis List: </span>
      <!-- TODO: Add disable functionality if no of axis = no of fields. -->
        <span class="w-75 d-inline-block add-y" v-on:click="addYAxis()">+</span>
      </div>

      <div v-for="(yAxis, yAxisIndex) in customizedYAxisList"
           :key="'y-axis-container-' + yAxisIndex">
        <div>
          <b-input v-model="yAxis.title"/>
        </div>
        <div>Plots:</div>
        <div class="ticker-tag-selected-list-container text-left my-3 mx-3"
             v-if="availableTags != null && Object.keys(availableTags).length > 0">
        <span v-for="(tags, tagSrc) in availableTags" :key="tagSrc"
              class="ticker-tag-selected p-2 bg-light border border-dark rounded-sm mr-1"
        >
          <span v-for="tag in tags" :key="tag.id">

            <span class="ticker-tag-selected p-1 m-1  border border-light rounded-pill"
                  v-b-tooltip.hover title="Click to Assign to axis"
                  v-bind:class=
                    "{
                    [tagClassListSelected]: (isTagSelectedForAxis(yAxisIndex, tag)),
                    [tagClassListDisabled]: (isTagSelectedSomewhereElse(yAxisIndex, tag)),
                    }"
                  v-on:click="assignTagToYAxis(yAxisIndex, tag)">
               {{tag.name}}
            </span>

          </span>
        </span>
        </div>
      </div>

    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfigureYAxis',
  props: {
    availableTags: null,
    yAxisList: null,
    chartDetails: null,
  },
  data() {
    return {
      customizedYAxisList: [],
      tagClassListSelected: 'selected bg-info',
      tagClassListDisabled: 'disabled',
    };
  },
  methods: {
    addYAxis() {
      // we don't need more axis than the field count, so return without adding a new axis.
      this.customizedYAxisList.push(
        {
          title: '',
          tags: [],
        },
      );
    },
    isTagSelectedForAxis(yAxisIndex, tag) {
      let isTagSelectedForAxis = false;
      this.customizedYAxisList[yAxisIndex].tags.forEach((yAxisTag) => {
        if (yAxisTag.id === tag.id) isTagSelectedForAxis = true;
      });
      return isTagSelectedForAxis;
    },
    isTagSelectedSomewhereElse(yAxisIndex, tag) {
      let isTagSelected = false;
      this.customizedYAxisList.forEach((yAxis, index) => {
        if (!yAxis.tags !== undefined) {
          yAxis.tags.forEach((yAxisTag) => {
            if (yAxisTag.id === tag.id && index !== yAxisIndex) isTagSelected = true;
          });
        }
      });
      return isTagSelected;
    },

    assignTagToYAxis(yAxisIndex, tag) {
      if (this.isTagSelectedSomewhereElse(yAxisIndex, tag)) {
        return;
      }
      if (this.isTagSelectedForAxis(yAxisIndex, tag)) {
        let indexOfTag = -1;
        // eslint-disable-next-line no-restricted-syntax
        for (const [tagIndex, yAxisTag] of this.customizedYAxisList[yAxisIndex].tags.entries()) {
          if (yAxisTag.id === tag.id) {
            indexOfTag = tagIndex;
            this.customizedYAxisList[yAxisIndex].tags.splice(indexOfTag, 1);
            break;
          }
        }
      } else {
        this.customizedYAxisList[yAxisIndex].tags.push(tag);
      }
    },
    updateYAxisConfiguration() {
      this.customizedYAxisList.forEach((yAxis) => {
        yAxis.plot = [];
        yAxis.tags.forEach((tag) => {
          const plot = {
            value: tag.name,
            connectNullData: true,
            type: 'line',
            // TODO: This is a hack. tag should also have the src. we need to fix this eventually.
            tagUuid: tag.uuid,
          };
          yAxis.plot.push(plot);
        });
        delete yAxis.tags;
      });
      this.$emit('customizeYAxisConfiguration', this.customizedYAxisList);
    },
  },
  mounted() {
  },
};
</script>

<style>
  .add-y {
    cursor: pointer;
  }
  .y-axis-configuration .ticker-tag-selected {
    background-color: gray;
  }

  .y-axis-configuration .ticker-tag-selected.disabled {
    background-color: lightgray;
    color: gray;
  }
</style>
